import { type FC, type JSX } from 'react';

import styles from './ResidentialComplexesList.css';

type ResidentialComplexesListProps = {
  complexesList: JSX.Element[];
  showMoreButton: JSX.Element | null | false;
};

export const ResidentialComplexesList: FC<ResidentialComplexesListProps> = props => {
  const { complexesList, showMoreButton } = props;

  return (
    <div className={styles['complexes']} data-testid="residential-complexes-list">
      <div className={styles['cards']} data-testid="residential-complexes-list-cards-wrapper">
        {complexesList}
      </div>
      {!!showMoreButton && (
        <div className={styles['button-wrapper']} data-testid="residential-complexes-list-show-more-button-wrapper">
          {showMoreButton}
        </div>
      )}
    </div>
  );
};
